import styled from 'styled-components';

export const GaugeContainer = styled.div`
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
`;

export const GaugeFill = styled.div<{ width: string; color: string }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${(props) => props.width};
  background-color: ${(props) => props.color};
  border-radius: 10px;
  transition: width 0.3s ease;
`;
